<div [ngClass]="labelPosition === 'top' ? 'flex flex-col gap-2' : 'flex items-center font-archivo gap-2'">
  <label *ngIf="label && labelPosition === 'top'" [for]="id" class="block text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo">{{label}} <span *ngIf="required"
      class="text-danger-500">*</span></label>

  <!-- Single checkbox -->
  <div *ngIf="!checkboxList.length" class="flex flex-col" [ngClass]="{ 'cursor-default': disabled, 'items-center': !errorMessage, 'items-start': errorMessage }">
    <label class="flex flex-row justify-items-start gap-2" [ngClass]="{ 'opacity-75 cursor-not-allowed': disabled }">
      <span
        class="w-[1.5rem] h-[1.5rem] min-w-[1.5rem] mt-[4px] min-h-[1.5rem]  border-2 flex flex-row items-center justify-center border-gray-500 has-[:checked]:border-0  has-[:checked]:bg-primary-500 rounded-md bg-white relative overflow-hidden" [ngClass]="disabled ? 'cursor-default' : 'cursor-pointer'">
        <input type="checkbox" [id]="id" class="peer sr-only" [checked]="checked" [disabled]="disabled"
          (change)="handleChange($event)" (blur)="handleBlur()">
        <NiFormIcon icon="checkboxCheck" iconClass="!w-[0.75rem] !h-[0.75rem]"></NiFormIcon>
      </span>
      <span *ngIf="label && labelPosition === 'right'" class="block leading-[2rem] text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo" [ngClass]="disabled ? 'cursor-default' : 'cursor-pointer'">{{label}} <span *ngIf="required" class="text-danger-500">*</span></span>
    </label>
    <div *ngIf="errorMessage" class="flex items-start justify-start min-h-[25px] w-full">
      <span class="text-danger-500 text-[14px]">{{errorMessage}}</span>
    </div>
  </div>

  <!-- Checkbox list -->
  <div *ngIf="checkboxList.length" class="flex flex-col gap-2">
    <div class="flex items-center gap-4 flex-wrap">
      <label *ngFor="let checkbox of checkboxList" [for]="checkbox.id" class="flex gap-2"
        [ngClass]="{ 'opacity-75 cursor-not-allowed': disabled }">
        <div
          class="w-[1.5rem] h-[1.5rem] min-w-[1.5rem] min-h-[1.5rem] shrink-0 border-2 flex flex-row items-center justify-center border-gray-500 has-[:checked]:border-0  has-[:checked]:bg-primary-500 rounded-md bg-white relative overflow-hidden" [ngClass]="checkbox.disabled ? 'cursor-default' : 'cursor-pointer'">
          <input [id]="checkbox.id" [name]="checkbox.id" type="checkbox" class="peer sr-only" [checked]="checkbox.checked"
            [value]="checkbox.value" [disabled]="checkbox.disabled" (change)="handleChange($event)" (blur)="handleBlur()">
          <NiFormIcon icon="checkboxCheck"  iconClass="!w-[0.75rem] !h-[0.75rem]"></NiFormIcon>
        </div>
        <div class="flex flex-col">
          <p *ngIf="checkbox.label" class="block text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1rem] font-normal font-archivo" [ngClass]="checkbox.disabled ? 'cursor-default' : 'cursor-pointer'">{{ checkbox.label }}</p>
          <p *ngIf="checkbox.description" class="text-sm text-gray-400">{{ checkbox.description }}</p>
        </div>
      </label>
    </div>
    <div *ngIf="errorMessage" class="flex items-start justify-start min-h-[25px] w-full">
      <span class="text-danger-500 text-[14px]">{{errorMessage}}</span>
    </div>
  </div>
</div>